/**
 * Nuxt 4.2+ injects <nuxt-error-overlay> on fatal errors in dev.
 * Even with 4.4 startMinimized for 4xx, the overlay can still cover error.vue
 * (SSR inject order, shadow DOM, persisted expanded state).
 * Strip it for 4xx so the branded Peekage 404 stays visible. Keep it for 5xx.
 */
export default defineNuxtPlugin({
    name: 'peekage-dev-error-overlay',
    enforce: 'post',
    setup() {
        if (!import.meta.dev) {
            return
        }

        const error = useError()

        const isClientError = (): boolean => {
            const current = error.value
            const statusCode = Number(current?.statusCode || current?.status || 0)
            return statusCode >= 400 && statusCode < 500
        }

        const stripOverlay = (): void => {
            if (!isClientError()) {
                return
            }
            document.querySelectorAll('nuxt-error-overlay').forEach((node) => {
                node.remove()
            })
        }

        stripOverlay()
        watch(error, stripOverlay, { immediate: true })

        const observer = new MutationObserver(stripOverlay)
        observer.observe(document.documentElement, { childList: true, subtree: true })
    },
})
